import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import EmptyBasket from "components/basket/EmptyBasket";
import { Spinner, ErrorComponent } from "components";
import { useCustomHistory, useUserWallet } from "hooks";
import { errorNotification } from "utils/Utils";

import {
  CartAction,
} from "store/actions";

import * as ROUTE_CONSTANTS from "routes/constants";
import { calculateCartGrossAmount } from "utils/Utils";
import BasketItemList from "components/basket/BasketItemListN";
import { BasketInfo } from "./BasketHeader";
import DeliveryChargesWaveOff from "./DeliveryChargesWaveOff";
import SpecialNote from "components/item/SpecialNote";
import PaymentSummary from "components/payement-summary";
import { Alert } from "components/ErrorComponent";

const STORE_PAGE_URL = ROUTE_CONSTANTS.OUTLET_STORE[1];

function BasketBody({showSpecialNote = true, showBRs = true}) {
  //hooks
  const dispatch = useDispatch();
  const params = useParams();
  const router = useCustomHistory();
  const userWallet = useUserWallet();
  //redux state
  const { error } = useSelector((state) => state?.Discounts);
  const { discountModal } = useSelector((state) => state?.NotPersist);
  const { selectedStore } = useSelector((state) => state?.store)
  const { isLoading } = useSelector((state) => state?.loader);
  const { discountInfo } = useSelector(
    (state) => state?.Discounts
  );
  const {
    cart,
    cartTotal,
    amountAfterDiscount,
    orderSplReq,
    deliveryFee,
    cartError,
  } = useSelector((state) => state?.cart);

  const { loyaltyApplied, loyaltyAmount } = useSelector(
    (state) => state?.Loyalty
  );

  const { DomainType } = useSelector((state) => state.AppReducer);
  useEffect(() => {
    updateCart();
    //eslint-disable-next-line
  }, [
    cart,
    discountInfo,
    loyaltyAmount,
    loyaltyApplied,
    userWallet,
    deliveryFee,
  ]);

  useEffect(() => {
    if (cartError) {
      errorNotification(cartError, "top-center");
      setTimeout(() => {
        dispatch(CartAction.clearCartError());
      }, 3000); // Clear error after 3 seconds
    }
  }, [cartError, dispatch]);

  //updating cart info
  const updateCart = () => {
    const { itemsGrossAmount, itemsNetPrice, orderGrossAmount } =
    calculateCartGrossAmount(cart, discountInfo, userWallet);
    dispatch(
      CartAction.updateCartPrice({
        originalPrice: itemsNetPrice,
        amountAfterDiscount: itemsGrossAmount,
        itemsGrossAmount,
        orderGrossAmount,
      })
    );
  };

  //increase and decrease item quantity
  const increaseItemQuantity = (id, index) => {
    const payload = { id, index };
    dispatch(CartAction.increaseItemQuantity(payload));
    updateCart();
  };
  const decreaseItemQuantity = (id, index) => {
    const payload = { id, index };
    dispatch(CartAction.decreaseItemQuantity(payload));
    updateCart();
  };

  const emptyBasket = () => {
    router(
      `${STORE_PAGE_URL}`,
      `/${params?.domainName}${STORE_PAGE_URL}`,
      DomainType
    );
  };

  const redirectToStorePage = () => {
    const STORE_PAGE_URL = "/store/store-detail";
    router(
      STORE_PAGE_URL,
      `/${params?.domainName}${STORE_PAGE_URL}`,
      DomainType
    );
  };
  if (isLoading) return <Spinner />;
  if (cart?.length <= 0) {
    return (
      <div className="flex flex-col items-center justify-center w-full h-full">
        <EmptyBasket backToHome={emptyBasket} />
      </div>
    );
  }
  return (
    <>
      <BasketInfo
        title={"Order Details"}
        subTitle={
          "Get your favorite dishes delivered straight to your doorstep."
        }
      />
     {selectedStore?.deliveryChargesWaiverInfo?.onOrderAmount?.isEnabled && <DeliveryChargesWaveOff price={selectedStore?.deliveryChargesWaiverInfo?.onOrderAmount?.amount} />}
      <BasketItemList
        showAllOrders={false}
        {...{ increaseItemQuantity, decreaseItemQuantity }}
        onSubHeaderClick={() => redirectToStorePage()}
      />
      {!discountModal && error && cart?.length >= 1 && (
        <Alert type="warning" title={error} />
      )}

      <PaymentSummary
        cartTotal={cartTotal}
        deliveryFee={deliveryFee}
        taxRate={selectedStore?.taxRate ?? 0}
        amountAfterDiscount={amountAfterDiscount}
        userWallet={userWallet}
        page="main"
        updateCart={updateCart}
        isSplitInProgress={false}
      />
    {showSpecialNote && <SpecialNote
        value={orderSplReq ?? ""}
        onChange={(e) => dispatch(CartAction.setOrderSplreq(e?.target?.value))}
      />}
       {
       showBRs && <>
       <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        </>
       }
  
      </>
  );
}

export default BasketBody;
